import { useState } from "react";
import { Button, Icon } from "semantic-ui-react";

import { CreateUpdateKioskModal, KioskDashboardTable } from "modules/KioskDashboard/components";
import "modules/KioskDashboard/KioskDashboard.scss";

export const KioskDashboard = () => {
  const [showCreateModal, setShowCreateModal] = useState(false);

  return (
    <div className="KioskDashboard">
      <div className="add-button-container">
        <Button basic icon className="add-btn" onClick={() => setShowCreateModal(true)}>
          <Icon className="plus" />
        </Button>
      </div>

      <KioskDashboardTable />
      <CreateUpdateKioskModal isOpen={showCreateModal} onClose={() => setShowCreateModal(false)} />
    </div>
  );
};
